import {ChangeDetectionStrategy, Component, Input, TemplateRef} from '@angular/core';

@Component({
  selector: 'jaspero-variable-content',
  templateUrl: './variable-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VariableContentComponent {
  @Input() isTemplate = false;
  @Input() item: string | TemplateRef<any>;
}



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/@systemic/ng-confirmations/components/variable-content/variable-content.component.ts